import store from "@/store";
import api from "./api";
import { update, shutdown } from "@intercom/messenger-js-sdk";

// Update Intercom with authenticated user data
// Intercom is initialized anonymously in App.vue, this upgrades it to authenticated
async function intercomBoot() {
  if (!store.getters["authentication/isLoggedIn"]) {
    console.warn("Intercom boot: User is not logged in.");
    // Intercom already initialized anonymously in App.vue
    return;
  }
  
  console.info("Intercom boot: User is logged in, fetching token...");
  try {
    const resp = await api.v2.get("user-account/user/intercom");
    if (resp.body?.token) {
      const updateConfig = {
        name: resp.body.name,
        intercom_user_jwt: resp.body.token,
      };
      
      // Use update() to transition from anonymous to authenticated
      update(updateConfig);
      console.info("Intercom updated with authenticated user data");
    } else {
      console.warn("Intercom boot: No token received from API");
    }
  } catch (error) {
    console.error("Intercom boot: Failed to fetch token", error);
  }
}

// Properly shutdown Intercom and return to anonymous mode on logout
function intercomReboot() {
  console.info("Intercom reboot: Shutting down authenticated session");
  shutdown();
}

export default {
  intercomBoot,
  intercomReboot,
};
